import _ from 'lodash';
import React, { CSSProperties } from 'react';
import { WppSelect, WppListItem } from 'buildingBlocks';

type DropdownItems = Array<{ key?: string | number, value: string | number, text: string | number }>;

type DropdownOptionProps = {
  defaultValue: string | number
  optionsValue: DropdownItems
  onChange: Function
  id: string
  style?: CSSProperties
};

const DropdownOption = ({ id, defaultValue, optionsValue, onChange, style }: DropdownOptionProps) => (
  <WppSelect
    id={id}
    onWppChange={(event: CustomEvent) => onChange(event.detail.value)}
    size="s"
    style={style}
    value={_.find(optionsValue, { value: defaultValue }) ? defaultValue : _.first(optionsValue).value}
  >
    {_.map(optionsValue, (option) => (
      <WppListItem key={option.value} value={option.value}>
        <p slot="label">{option.text}</p>
      </WppListItem>
    ))}
  </WppSelect>
);

export default DropdownOption;
